// extracted by mini-css-extract-plugin
export default {"wrapper":"database-type_wrapper__nLi6s"};